<script lang="ts" context="module">
	export const KEY_GROUP = 'group';
</script>
<script lang="ts">
	import type { RestaurantDynamic, RestaurantSemiStatic, TileRestaurant, TileStack } from "$lib/def/landing";
	import type { DealsLoader } from '$lib/serv/food-landing';
	import { Vertical } from '$lib/def/verticals';
	import Header from '$lib/ui/shared/Header.svelte';
	import LazyBackgroundImage from "$lib/ui/shared/LazyBackgroundImage.svelte";
	import { queryFrom } from "$lib/util/url";
	import { fly } from 'svelte/transition';
	import Tile from './Tile.svelte';
import type { Choice } from "$lib/def/seo/choice";

	export let data: TileStack;
	export let restaurants: RestaurantSemiStatic[];
	export let dynamic: RestaurantDynamic[] | undefined;
	export let deals: DealsLoader | null;
	export let expanded: boolean;
	export let animationDelay = 0;
	export let searchParams: Record<string, string>;

	let tiles: TileRestaurant[];
	$: {
		tiles = data.payload.restaurant_ids.map(id => ({
			type: Vertical.Store,
			payload: { id },
		}))
	}

	$: vertical = getVerticalFromUrl(searchParams);

	const getVerticalFromUrl = (params: Record<string, string>) => params['vertical'] as Vertical || Vertical.Restaurant;

	async function getBrand(groupdId: number | string) {
		if (!groupdId) return {slug: '', name: ''};
		const res = await fetch(`/api/seodata/choices?adminId=${groupdId}`).catch(() => null);
		const data = await res?.json() as Choice[];
		if (res?.ok) return data?.find(d => true) ?? {slug: '', name: ''};
		// throw 'Group not found.'
		return {slug: '', name: ''};
	}
</script>

	{#if expanded}
		{@const promiseBrand = getBrand(data.payload.group_id)}
		<Header back={queryFrom(searchParams).remove(KEY_GROUP).toUrl()}>
			{#await promiseBrand then {slug, name}}
				{#if slug}
					<a class="display-l bold" href={`/delivery/${vertical}s/${slug}-near-me`}>{data.payload.title ?? name}</a>
				{:else}
					<h3 class="display-l bold">{data.payload.title}</h3>
				{/if}
			{:catch error}
				<!-- we don't care -->
			{/await}
			<h4 class="headline-m bold">{tiles.length} near you</h4>
		</Header>

		<div class="grid restaurants">
			{#each tiles as tile}
				{@const id = tile.payload.id}
				{@const ss = restaurants?.find(r => r.id === id)}
				{@const d = dynamic?.find(r => r.id === id)}
				{@const ds = deals?.restaurants?.get(id)}
				<Tile {searchParams} tile={{ ...tile, type: vertical}} semistatic={ss} dynamic={d} deals={ds}/>
			{/each}
		</div>
	{:else if data.payload}
		{@const item = data.payload}
		<a href={queryFrom(searchParams).set(KEY_GROUP, item.group_id).toUrl()} class="card stack" in:fly|global={{y: 20, delay: animationDelay}} data-testid={`group_${item.group_id}`}>

			<LazyBackgroundImage image={[item.images?.restaurant_header, 400]} alt={item.title} />

			<div class="blur">
				<LazyBackgroundImage image={[item.images?.restaurant_header, 400]} alt={item.title} />
				<LazyBackgroundImage image={[item.images?.restaurant_header, 400]} alt={item.title} />
			</div>

			<div class="text stack flex flex-nowrap mobile small-gap">
				<h5 class="name label-xl bold ellipses short">{item.title}</h5>
				<div class="stack-button label-xl medium nowrap">{data.payload.restaurant_ids.length} near you <span class="icon icon-chevron-right-20"></span></div>
			</div>

		</a>
	{/if}
